namespace advisorop.components.servicer {
    
    export class CustodianAdvisoryFirmMapController{
        custodianAdvisoryFirmCreated: any;
        custodianAdvisoryFirmModified: any;
        custodianAdvisoryFirmDeleted: any;

        //we need it just to control select-custodian control
        selCustodian: domains.ICustodian;
        selCustodianId: number;
        custodianLink: domains.ICustodianAdvisoryFirm;
        advisoryFirmId: number;
        model: domains.ICustodianAdvisoryFirm = {};
        
        constructor(private servicerService: services.ServicerService) {
            this.model = {                
            };
        }

        custodianSelected(custodian: domains.ICustodian) {            
            if (custodian)
                this.model.custodianId = custodian.id;
        }

        linkCustodianAndAdvisoryFirm(): void {

            this.model.advisoryFirmId = this.advisoryFirmId;

            this.servicerService.createCustodianAdvisoryFirm(this.model)
                .then(data => {

                    this.model = {};

                    this.selCustodian = null;

                    this.custodianAdvisoryFirmCreated({ custodianAdvisoryFirm: data.data });
                })
                .catch(data => {
                    toastr.error("Operation has not been completed! Error " + data.status + " " + data.data);
                });
            
        };

        relinkCustodianAndAdvisoryFirm(): void {

            this.model.advisoryFirmId = this.advisoryFirmId;

            this.servicerService.relinkCustodianAdvisoryFirm(this.model)
                .then(data => {

                    this.model = {};

                    this.selCustodian = null;

                    this.custodianAdvisoryFirmModified({ custodianAdvisoryFirm: data.data });
                })
                .catch(data => {
                    toastr.error("Operation has not been completed! Error " + data.status + " " + data.data);
                });

        };

        unlinkCustodianAndAdvisoryFirm(): void {
            this.servicerService.deleteCustodianAdvisoryFirm(this.model.id)
                .then(data => {

                    var custodianAdvisoryFirmLinkId = this.model.id;

                    this.model = {};

                    this.custodianAdvisoryFirmDeleted({ custodianAdvisoryFirmLinkId: custodianAdvisoryFirmLinkId });
                })
                .catch(data => {
                    toastr.error("Operation has not been completed! Error " + data.status + " " + data.data);
                });

            this.selCustodian = null;
        };
        
        $onInit(): void {                       
        }

        $onChanges(changes) {
            for (let prop in changes) {
                if (prop == "custodianLink") {                    
                    if (changes[prop]) {                        
                        this.model = changes[prop].currentValue;
                        //console.log("custodian-advisory-firm-map: In OnChanges:", changes[prop])
                        if (changes[prop].currentValue.custodian != undefined)
                            this.selCustodianId = changes[prop].currentValue.custodian.id;
                    }
                    else {
                        this.model = {};
                    }
                }
            }
        }
      

    }



    class CustodianAdvisoryFirmMap implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {
                advisoryFirmId: "<",
                custodianLink: "<",
                custodianAdvisoryFirmCreated: "&",
                custodianAdvisoryFirmModified: "&",
                custodianAdvisoryFirmDeleted: "&"
            };
            this.controller = ["servicerService", CustodianAdvisoryFirmMapController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/custodian-advisory-firm-map.html';            
        }
    }
    angular.module(Constants.APP).component("custodianAdvisoryFirmMap", new CustodianAdvisoryFirmMap());
    
}